export const MINTED_CHECK_CAP = 5000;

export const GAS_INCREASE = 1.06;

export const DISABLE_CHECK = false;
